<template>
  <div class="visor container is-fluid">
    <div class="columns">
      <div class="column is-3">
        <h4 class="is-size-4-desktop">Visor de pedido</h4>
        <h4 v-if="bodega" class="is-size-6-desktop">
          Sucursal: {{ bodega.sucursal.nombre }} - {{ bodega.nombre }}
        </h4>
        <div v-else class="notification is-info">
          El usuario identificado no se encuentra asignado a una sucursal y/o
          bodega. Favor contactar al administrador.
        </div>
      </div>
    </div>
    <visor-pedidos-filtros
      :key="filtroKey"
      :filtro="filtro"
      :desde-monitor="desdeMonitor"
      :cargando="cargando"
      :modo="modo"
      @search="buscarPedidoHandle"
    />
    <div v-if="pedidoExiste && pedidos.length > 0" class="detalle-pedido">
      <b-loading
        :is-full-page="true"
        :active.sync="cargando"
        :can-cancel="false"
      />
      <div v-if="hayMedidaInventario">
        <small class="has-text-info">
          <strong>
            * Hay art&iacute;culos que tienen una unidad de medida de venta
            distinta a la de unidad de medida de inventario. Cuando esto ocurre
            las unidades y/o cantidad de inventario aparecen en un globo azul.
          </strong>
        </small>
      </div>
      <visor-pedido
        v-for="(item, index) in pedidos"
        :key="`visor-pedido-${item.id}-${index}`"
        class="visor-pedido"
        :hay-pedido-padre="hayPedidoPadre(item.id)"
        :pedido="item"
        @update="updatePedidoHandle"
      >
      </visor-pedido>
    </div>
    <div v-if="!pedidoExiste" class="detalle-pedido notification is-info">
      El picking list para tipo de documento {{ tipoDocumento }} con N&deg;
      {{ filtro.numeroDocumento }} no ha sido procesado por MOPI!
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { pedidoService } from '@/services'
import VisorPedidosFiltros from '@/components/visor/VisorPedidosFiltros.vue'
import VisorPedido from '@/components/visor/VisorPedido.vue'

export default {
  name: 'VisorPedidos',
  components: {
    VisorPedidosFiltros,
    VisorPedido
  },
  props: {
    modo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pedidosIds: [],
      pedidos: [],
      filtro: null,
      cargando: false,
      desdeMonitor: false,
      pedidoExiste: true,
      esMultiple: false,
      filtroKey: 1
    }
  },
  computed: {
    ...mapGetters('monitor', ['bodega']),
    tipoDocumento() {
      if (this.filtro) {
        switch (this.filtro.tipoDocumento) {
          case 'F':
            return 'Factura'
          case 'B':
            return 'Boleta'
          case 'P':
            return 'Pedido'
        }
      }
      return ''
    },
    hayMedidaInventario() {
      return this.pedidos.some((x) =>
        x.items.some(
          (y) => y.unidadMedida !== (y.unidadMedidaInventario ?? y.unidadMedida)
        )
      )
    }
  },
  watch: {
    pedidosIds() {
      Promise.all(this.pedidosIds.map((id) => this.cargarPedido(id))).then(
        (_) => (this.cargando = false)
      )
    },
    filtro() {
      this.filtroKey++
    }
  },
  created() {
    const id = this.$route.params.id
    this.desdeMonitor = false
    if (id) {
      this.desdeMonitor = true
      return this.buscarPedidoHandle({
        tipoDocumento: 'P',
        numeroDocumento: id,
        bodegaId: this.bodega.id
      })
    }
  },
  methods: {
    buscarPedidoHandle(payload) {
      this.pedidos = []
      this.cargando = true
      this.filtro = payload
      pedidoService
        .getPedidoByParams(payload)
        .then((response) => {
          this.pedidoExiste = true
          this.pedidosIds = response.data.map((item) => item.id)
          this.esMultiple = response.data.length > 1
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.pedidoExiste = false
            this.esMultiple = false
            this.cargando = false
            this.pedidosIds = []
          }
        })
    },
    cargarPedido(pedidoId) {
      if (!this.pedidoExiste) return null
      return pedidoService
        .getPedido(pedidoId)
        .then((response) => {
          this.pedidos = this.pedidos.filter((x) => x.id !== pedidoId)
          this.pedidos.push(response.data)
          this.pedidos = this.pedidos.sort(
            (a, b) => parseInt(a.id) - parseInt(b.id)
          )
        })
        .catch((error) => this.procesarError(error))
    },
    updatePedidoHandle(payload) {
      this.cargarPedido(payload)
    },
    hayPedidoPadre(pedidoId) {
      const pedido = this.pedidos.filter((p) => p.id === pedidoId)[0]
      // Si pedidoId no existe, no hay pedido padre...
      if (!pedido) return false
      // Si hay pedido y no hay pedido padre, es
      if (!pedido.pedidoPadreId) return true
      const pedidos = this.pedidos.filter(
        (p) => p.pedidoPadreId === pedido.pedidoPadreId
      )
      return !pedidos.every((x) => !x.esSubpedido)
    }
  }
}
</script>

<style lang="scss" scoped>
.visor-pedido {
  margin-bottom: 20px;
}
</style>
